import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PublicPage from "../../PublicPage";
import TransactionHeader from "./TransactionHeader";
import SellerFlowTrack from "./SellerFlowTrack";
import DealInsuranceStage from "./insurance/DealInsuranceStage";
import { OWNERSHIP_TRACK } from "./ownership/DealOwnershipStage";

// "Försäkra bilen" on a page of its own — where the BUYER lands a few seconds after the seller has
// reported the change of ownership (DealOwnershipStage).
//
// A DEMO page: the offers, the car and the policy are hard-coded in the front end and nothing is
// read from or saved to the backend, so unlike its neighbours it makes no API call at all.
//
// It is a deal-flow path (lib/dealSession), so the same rules as the stages before it apply: the
// idle timeout (app-wide, SessionTimeoutManager) and the "Leave the deal?" question when the buyer
// navigates away (DealSessionManager). The deal is complete, so that question takes nobody else
// with it - only this user goes home.
export default function DealInsurancePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  // The step is over: on to "Köpet är genomfört", carrying (in memory only) what the buyer did.
  const finish = useCallback(
    (insurance) => navigate(`/PurchaseComplete/${id}`, { state: { insurance }, replace: true }),
    [navigate, id],
  );

  return (
    <PublicPage>
      <div className="flex min-h-screen flex-col bg-ds-canvas">
        <TransactionHeader />
        <main className="ds-scope w-full flex-1 px-4 pb-16 pt-6 md:px-6">
          <div className="ds-form mx-auto w-full">
            {/* Every step of the deal is behind the buyer now: the rail stands complete. */}
            <div className="flow-shell-track">
              <SellerFlowTrack activeStep={5} t={t} milestones={OWNERSHIP_TRACK} ns="buyer" terminal />
            </div>
            <DealInsuranceStage onFinish={finish} />
          </div>
        </main>
      </div>
    </PublicPage>
  );
}
